import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { readCookie, writeCookie } from '@/tools/tools';
import { messageSimple as _messageSimple, queryFirstBuy as _queryFirstBuy } from '@/services/http';
/**
 * getters
 */
// export const getters: GetterTree<notifysState, RootState> = {
//   addresslist: (state: notifysState) => state.notifysList,
// };
/**
 * mutations
 */
export var mutations = {
  // 收货列表
  USERINFORLIST: function USERINFORLIST(state, payload) {
    state.notifysList = payload;
    writeCookie('notifysList', state.notifysList);
  },
  // 收货列表
  QUERYFIRSTBUY: function QUERYFIRSTBUY(state, payload) {
    state.serviceList = payload;
  }
};
/**
 * actions
 */
export var actions = {
  messageSimple: function messageSimple(_ref) {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var commit, res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit;
            _context.next = 3;
            return _messageSimple({
              companyId: 1
            });
          case 3:
            res = _context.sent;
            commit('USERINFORLIST', res.data.data);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  queryFirstBuy: function queryFirstBuy(_ref2) {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var commit, res;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            commit = _ref2.commit;
            _context2.next = 3;
            return _queryFirstBuy({
              companyId: 1
            });
          case 3:
            res = _context2.sent;
            commit('QUERYFIRSTBUY', res.data.data);
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }
};
/**
 * state
 */
export var state = {
  notifysList: readCookie('notifysList') ? readCookie('notifysList') : {},
  serviceList: {}
};
var namespaced = true;
export var notifys = {
  namespaced: namespaced,
  state: state,
  mutations: mutations,
  actions: actions
};